import { FieldName } from './FieldName';

export default FieldName;
